(function () {
  function setMediaAspect(media, aspect) {
    if (!media || !aspect || !isFinite(aspect) || aspect <= 0) return;
    media.style.setProperty('--mt-youtube-text-aspect', String(aspect));
  }

  function syncAspectFromPoster(media) {
    var posterUrl = media.dataset.posterUrl;
    if (!posterUrl) return;

    var img = new Image();
    img.onload = function () {
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        setMediaAspect(media, img.naturalWidth / img.naturalHeight);
      }
    };
    img.src = posterUrl;
  }

  function syncAspectFromVideo(media, video) {
    if (!video) return;

    function apply() {
      if (video.videoWidth > 0 && video.videoHeight > 0) {
        setMediaAspect(media, video.videoWidth / video.videoHeight);
      }
    }

    if (video.readyState >= 1) {
      apply();
    } else {
      video.addEventListener('loadedmetadata', apply, { once: true });
    }
  }

  function syncMediaAspect(section) {
    var media = section.querySelector('[data-mt-media]');
    if (!media) return;

    var wrapper = media.querySelector('[data-mt-youtube-wrapper]');
    var videoType = wrapper && wrapper.dataset.videoType;
    var hasAspect = media.style.getPropertyValue('--mt-youtube-text-aspect');

    if (videoType === 'upload') {
      syncAspectFromVideo(media, media.querySelector('[data-mt-native-video]'));
    }

    if (!hasAspect || videoType === 'youtube') {
      syncAspectFromPoster(media);
    }
  }

  function playYouTube(wrapper, player) {
    var youtubeId = player.dataset.youtubeId;
    if (!youtubeId || wrapper.classList.contains('is-playing')) return;

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube.com/embed/' +
      youtubeId +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = player.dataset.videoTitle || 'YouTube video';

    player.style.backgroundImage = 'none';
    player.appendChild(iframe);
    wrapper.classList.add('is-playing');
  }

  function playUpload(wrapper, player) {
    var video = wrapper.querySelector('[data-mt-native-video]');
    if (!video || wrapper.classList.contains('is-playing')) return;

    player.style.backgroundImage = 'none';
    wrapper.classList.add('is-playing');
    video.controls = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function initYouTubeText(section) {
    syncMediaAspect(section);

    var wrapper = section.querySelector('[data-mt-youtube-wrapper]');
    if (!wrapper) return;

    var player = wrapper.querySelector('[data-mt-youtube-player]');
    var playBtn = wrapper.querySelector('[data-mt-youtube-play]');
    var overlay = wrapper.querySelector('[data-mt-youtube-overlay]');
    var videoType = wrapper.dataset.videoType || 'youtube';
    if (!player) return;

    if (videoType === 'youtube' && !player.dataset.youtubeId) return;
    if (videoType === 'upload' && !wrapper.querySelector('[data-mt-native-video]')) return;

    function playVideo() {
      if (videoType === 'upload') {
        playUpload(wrapper, player);
      } else {
        playYouTube(wrapper, player);
      }
    }

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        playVideo();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        e.stopPropagation();
        playVideo();
      });
    }
  }

  function initAll() {
    document
      .querySelectorAll('.mt-youtube-text[data-section-id]')
      .forEach(initYouTubeText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.mt-youtube-text[data-section-id]');
    if (section) initYouTubeText(section);
  });
})();
